import { render, staticRenderFns } from "./selection.vue?vue&type=template&id=7ffbb02a&scoped=true&"
import script from "./selection.vue?vue&type=script&lang=js&"
export * from "./selection.vue?vue&type=script&lang=js&"
import style0 from "./selection.vue?vue&type=style&index=0&id=7ffbb02a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffbb02a",
  null
  
)

export default component.exports